import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions, Typography, Button, useMediaQuery } from '@material-ui/core';

// STYLES
import { DialogStyled, CloseIcon } from './styles';

const DialogInfo = ({ open, onClose, title, closeButtonDisabled, dialogProps, ...restProps }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  return (
    <DialogStyled
      className="dialog-info"
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      {...dialogProps}
    >
      <DialogContent className="dialog-info__content">
        <CloseIcon size="medium" aria-label="close" onClick={onClose}>
          <i className="icon-close" />
        </CloseIcon>
        {title && (
          <Typography className="dialog-info__title m-b-20" variant={downXs ? 'h4' : 'h3'}>
            {title}
          </Typography>
        )}
        <div className="content" {...restProps} />

        {!closeButtonDisabled && (
          <DialogActions>
            <Button className="sizeExtraLarge" color="secondary" onClick={onClose}>
              {t('buttons.close')}
            </Button>
          </DialogActions>
        )}
      </DialogContent>
    </DialogStyled>
  );
};

DialogInfo.defaultProps = {
  open: false,
  title: '',
  closeButtonDisabled: false,
  dialogProps: {},
};

DialogInfo.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  closeButtonDisabled: PropTypes.bool,
  dialogProps: PropTypes.object,
};

export default React.memo(DialogInfo);
